// lib/utils.ts

/**
 * Format price as Canadian currency
 */
export function formatPrice(price: number): string {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
}

/**
 * Format date for display
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString + 'T00:00:00'); // Prevent timezone shift
  return date.toLocaleDateString('en-CA', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Format availability date for display
 */
export function formatAvailability(dateString: string): string {
  const date = new Date(dateString + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  if (date <= today) {
    return 'Available Now';
  }
  
  return `Available ${date.toLocaleDateString('en-CA', { 
    month: 'short', 
    day: 'numeric' 
  })}`;
}

/**
 * Generate URL-friendly slug from string
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Classnames helper (simple version)
 */
export function cn(...classes: (string | boolean | undefined | null | 0)[]): string {
  return classes.filter((c): c is string => typeof c === 'string' && c.length > 0).join(' ');
}

/**
 * Get score color based on Walk Score value
 */
export function getScoreColor(score: number): string {
  if (score >= 90) return 'bg-emerald-500';
  if (score >= 70) return 'bg-emerald-400';
  if (score >= 50) return 'bg-amber-400';
  if (score >= 25) return 'bg-orange-400';
  return 'bg-red-400';
}

/**
 * Get score description based on Walk Score value
 */
export function getScoreDescription(score: number, type: 'walk' | 'transit' | 'bike'): string {
  if (type === 'walk') {
    if (score >= 90) return "Walker's Paradise";
    if (score >= 70) return 'Very Walkable';
    if (score >= 50) return 'Somewhat Walkable';
    if (score >= 25) return 'Car-Dependent';
    return 'Almost All Errands Require a Car';
  }
  if (type === 'transit') {
    if (score >= 90) return 'Excellent Transit';
    if (score >= 70) return 'Excellent Transit';
    if (score >= 50) return 'Good Transit';
    if (score >= 25) return 'Some Transit';
    return 'Minimal Transit';
  }
  // bike
  if (score >= 90) return "Biker's Paradise";
  if (score >= 70) return 'Very Bikeable';
  if (score >= 50) return 'Bikeable';
  return 'Somewhat Bikeable';
}
